// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { setRememberMeRequest } from "@stoneage/App/Services/KeepMeSignedIn/KeepMeSignedIn";

type HandlerType = ApiHandler<
    { rememberMe: boolean } & HasOnSuccess<boolean> & HasOnError<string>,
    ServiceResult<undefined>
>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await setRememberMeRequest(props.apiParameter.rememberMe);
};

export const OnSuccess: HandlerType = props => {
    if (props.apiResult && props.apiResult.successful) {
        props?.parameter?.onSuccess?.(props.apiParameter.rememberMe);
    }
};

export const OnError: HandlerType = props => {
    if (props.apiResult && !props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, OnSuccess, OnError];

const setRememberMe = createHandlerChainRunner(chain, "setRememberMe");
export default setRememberMe;
